import { render, staticRenderFns } from "./studentPublic.vue?vue&type=template&id=218d69ab&scoped=true&"
import script from "./studentPublic.vue?vue&type=script&lang=js&"
export * from "./studentPublic.vue?vue&type=script&lang=js&"
import style0 from "./studentPublic.vue?vue&type=style&index=0&lang=css&"
import style1 from "./studentPublic.vue?vue&type=style&index=1&id=218d69ab&scoped=true&lang=css&"
import style2 from "./studentPublic.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d69ab",
  null
  
)

export default component.exports